import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, Card, Row, Col, DatePicker } from 'antd';

export const BusCompanyCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/bus/companies',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Yangi avtobus kompaniyasi">
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card title="Asosiy ma'lumotlar">
              <Form.Item
                label="Kompaniya nomi"
                name="name"
                rules={[{ required: true, message: 'Nomni kiriting' }]}
              >
                <Input placeholder="SafarGo Express" />
              </Form.Item>

              <Form.Item
                label="Yuridik nomi"
                name="legalName"
                rules={[{ required: true, message: 'Yuridik nomni kiriting' }]}
              >
                <Input placeholder="SafarGo Express MCHJ" />
              </Form.Item>

              <Form.Item
                label="Telefon raqam"
                name="contactPhone"
                rules={[
                  { required: true, message: 'Telefon raqamni kiriting' },
                  { pattern: /^\+998\d{9}$/, message: 'Format: +998XXXXXXXXX' },
                ]}
              >
                <Input placeholder="+998901234567" />
              </Form.Item>

              <Form.Item label="Email" name="email">
                <Input placeholder="info@company.uz" type="email" />
              </Form.Item>

              <Form.Item label="Manzil" name="address">
                <Input.TextArea placeholder="Kompaniya manzili" rows={2} />
              </Form.Item>
            </Card>

            <Card title="Tizimga kirish" style={{ marginTop: 24 }}>
              <Form.Item
                label="Login (username)"
                name="username"
                rules={[{ required: true, message: 'Loginni kiriting' }]}
              >
                <Input placeholder="safargoexpress" />
              </Form.Item>

              <Form.Item
                label="Parol"
                name="password"
                rules={[
                  { required: true, message: 'Parolni kiriting' },
                  { min: 6, message: "Parol kamida 6 ta belgidan iborat bo'lishi kerak" },
                ]}
              >
                <Input.Password placeholder="Parolni kiriting" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card title="Yuridik ma'lumotlar">
              <Form.Item label="STIR (INN)" name="inn">
                <Input placeholder="123456789" />
              </Form.Item>

              <Form.Item label="THSHT (OKED)" name="oked">
                <Input placeholder="49310" />
              </Form.Item>

              <Form.Item label="MFO" name="mfo">
                <Input placeholder="01033" />
              </Form.Item>

              <Form.Item label="Bank hisobi" name="bankAccount">
                <Input placeholder="20208000123456789012" />
              </Form.Item>

              <Form.Item label="Bank nomi" name="bankName">
                <Input placeholder="Ipoteka Bank" />
              </Form.Item>
            </Card>

            <Card title="Direktor ma'lumotlari" style={{ marginTop: 24 }}>
              <Form.Item label="Direktor ismi" name="directorName">
                <Input placeholder="Alijon Valiyev" />
              </Form.Item>

              <Form.Item label="Direktor telefoni" name="directorPhone">
                <Input placeholder="+998901234567" />
              </Form.Item>
            </Card>

            <Card title="Shartnoma" style={{ marginTop: 24 }}>
              <Form.Item label="Shartnoma raqami" name="contractNumber">
                <Input placeholder="SG-2024-001" />
              </Form.Item>

              <Form.Item label="Shartnoma sanasi" name="contractDate">
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
